import { render, staticRenderFns } from "./LogoutConfirmModal.vue?vue&type=template&id=396315a1&scoped=true"
import script from "./LogoutConfirmModal.vue?vue&type=script&lang=js"
export * from "./LogoutConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396315a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('396315a1')) {
      api.createRecord('396315a1', component.options)
    } else {
      api.reload('396315a1', component.options)
    }
    module.hot.accept("./LogoutConfirmModal.vue?vue&type=template&id=396315a1&scoped=true", function () {
      api.rerender('396315a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Meet/Modal/LogoutConfirmModal.vue"
export default component.exports